import styled from 'styled-components';
import { WizardContent } from '../../components/WizardContent';

const Container = styled(WizardContent)``;

const Box = styled.div`
  display: flex;
`;

const List = styled.div`
  display: grid;
  grid-template-columns: 150px 150px;
`;

const Module = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
`;
export { Box, Module, Container, List };
